export const sleep = (seconds: number) => {
  return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
};



// WEBPACK FOOTER //
// /local/p4clients/pkgbuild-const/src/utils/sleep.ts